import { styled } from 'styled-components';

import { bodySmallText, colors, spacing } from '#/theme/theme';

export const SmallFilePickerFilenameBody = styled.div`
  display: flex;
  gap: ${spacing[8]};
  flex: 1;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  font-size: 14px;

  > * {
    /* Make link and remove button position relative so they capture click in place of the input */
    position: relative;
  }

  > a {
    display: block;
    max-width: 100%;
    overflow: hidden;
  }
`;

export const SmallFilePickerFilenameText = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
  max-width: 100%;
  min-width: 0;
  width: 100%;
`;

export const SmallFilePickerFilenameLastUpdated = styled.p`
  ${bodySmallText};
  margin: 0;
  color: ${colors.lightContentGrey};
  white-space: nowrap;
`;
